import type { SenderAttachment } from "@components/Sender/type";

/** Stable key for uploaded images; changes when user adds/removes/replaces images. */
export function computePortfolioImageFingerprint(
  images: SenderAttachment[],
): string {
  return images
    .filter((item) => item.status === "done" && item.url)
    .map((item) => item.url)
    .join("|");
}
